import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import transportImg from '../assets/transport.jpg';
import './Approvisionnement.css';

const AVANTAGES = [
  {
    title: 'Maîtrise du marché chinois',
    desc: 'Notre connaissance approfondie des pratiques commerciales et industrielles chinoises nous permet de sécuriser chaque étape de votre approvisionnement.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
  {
    title: 'Suivi en temps réel',
    desc: 'Nous assurons un suivi rigoureux de vos commandes, de la confirmation fournisseur jusqu\'à la livraison finale, avec des points d\'avancement réguliers.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    title: 'Contrôle de conformité',
    desc: 'Vérification systématique de la conformité des produits aux spécifications convenues avant tout départ d\'usine.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
  },
  {
    title: 'Réactivité & Flexibilité',
    desc: 'Une équipe disponible et réactive pour gérer les imprévus, renégocier les délais et adapter les volumes selon l\'évolution de vos besoins.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
];

const STEPS = [
  {
    num: '01',
    title: 'Analyse des besoins',
    desc: 'Compréhension précise de vos volumes, délais, budgets et exigences qualité pour définir la stratégie d\'approvisionnement adaptée.',
  },
  {
    num: '02',
    title: 'Sélection & Validation',
    desc: 'Sélection des fournisseurs qualifiés, négociation des conditions commerciales et validation des échantillons.',
  },
  {
    num: '03',
    title: 'Passation de commandes',
    desc: 'Rédaction et transmission des bons de commande, coordination avec les fournisseurs et confirmation des délais de production.',
  },
  {
    num: '04',
    title: 'Suivi de production',
    desc: 'Supervision de l\'avancement en usine avec alertes préventives en cas de retard ou d\'anomalie détectée.',
  },
  {
    num: '05',
    title: 'Contrôle qualité',
    desc: 'Inspection des produits finis avant expédition pour garantir la conformité avec vos cahiers des charges.',
  },
  {
    num: '06',
    title: 'Coordination logistique',
    desc: 'Organisation du transport, gestion des documents douaniers et suivi jusqu\'à la livraison dans vos entrepôts.',
  },
];

const COMPARE = [
  {
    aspect: 'Suivi des commandes',
    avec: 'Suivi continu avec reporting régulier et alertes proactives',
    sans: 'Dépendance totale au fournisseur, sans visibilité réelle',
  },
  {
    aspect: 'Barrière linguistique',
    avec: 'Communication fluide en chinois, français et anglais',
    sans: 'Malentendus fréquents liés à la langue et à la culture',
  },
  {
    aspect: 'Conformité produits',
    avec: 'Contrôle qualité systématique avant départ d\'usine',
    sans: 'Risque élevé de non-conformité découverte à réception',
  },
  {
    aspect: 'Gestion des litiges',
    avec: 'Médiation directe sur place avec le fournisseur',
    sans: 'Litiges longs et coûteux sans interlocuteur local',
  },
  {
    aspect: 'Délais',
    avec: 'Anticipation des retards et plans de contingence',
    sans: 'Retards non anticipés impactant votre chaîne de valeur',
  },
];

const SERVICES = [
  {
    title: 'Négociation fournisseurs',
    desc: 'Négociation des prix, délais et conditions de paiement pour optimiser votre rentabilité.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    title: 'Gestion des commandes',
    desc: 'Prise en charge complète du processus de commande, de la validation au paiement fournisseur.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
      </svg>
    ),
  },
  {
    title: 'Suivi de production',
    desc: 'Supervision régulière de l\'avancement en usine avec reporting hebdomadaire.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/><polyline points="3 9 21 9"/>
        <polyline points="9 21 9 9"/>
      </svg>
    ),
  },
  {
    title: 'Inspection qualité',
    desc: 'Contrôle sur site des produits finis avant expédition selon vos cahiers des charges.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <polyline points="9 11 11 13 15 9"/>
      </svg>
    ),
  },
  {
    title: 'Logistique & Transport',
    desc: 'Organisation du fret maritime ou aérien et coordination avec les transitaires.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="1"/>
        <path d="M16 8h4l3 5v3h-7V8z"/>
        <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
      </svg>
    ),
  },
  {
    title: 'Gestion douanière',
    desc: 'Préparation des documents d\'importation et coordination avec les services douaniers.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/>
      </svg>
    ),
  },
];

const FAQS = [
  {
    q: 'Comment GSSG sécurise-t-il mon approvisionnement en Chine ?',
    a: 'Nous intervenons à chaque étape critique : sélection des fournisseurs, négociation, suivi de production, contrôle qualité et coordination logistique. Notre équipe terrain en Chine vous garantit une visibilité totale sur l\'avancement de vos commandes.',
  },
  {
    q: 'Pouvez-vous intervenir directement en Chine si nécessaire ?',
    a: 'Oui. En cas de nécessité — litige avec un fournisseur, problème qualité critique ou commande stratégique — nous pouvons déployer sur place notre responsable supply chain. Ayant vécu 10 ans en Chine, il est parfaitement trilingue (chinois, français, anglais) et capable d\'intervenir efficacement auprès des usines et partenaires locaux.',
  },
  {
    q: 'Travaillez-vous uniquement avec des fournisseurs chinois ?',
    a: 'Non. Bien que la Chine soit notre marché principal, nous accompagnons également l\'approvisionnement auprès de fournisseurs situés dans d\'autres pays (Vietnam, Inde, Turquie…). Notre responsable supply chain peut se déplacer dans ces pays si la situation l\'exige.',
  },
  {
    q: 'Comment gérez-vous les retards ou problèmes de qualité ?',
    a: 'Grâce à notre suivi proactif en usine, nous anticipons la plupart des problèmes avant qu\'ils n\'impactent vos délais. En cas d\'anomalie, nous alertons immédiatement, proposons des solutions alternatives et, si nécessaire, envoyons un représentant sur place pour résoudre le litige directement avec le fournisseur.',
  },
  {
    q: 'Quels sont vos délais d\'intervention pour une nouvelle commande ?',
    a: 'Après validation de votre brief, nous pouvons lancer le processus de sourcing et de commande sous 48 à 72 heures. Les délais de production dépendent ensuite du fournisseur et du type de produit, mais nous vous communiquons un calendrier précis dès le démarrage.',
  },
];

export default function Approvisionnement() {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();

  const goContact = () => navigate('/', { state: { scrollTo: 'contact-section' } });

  return (
    <div className="ap-page">

      {/* ── HERO ── */}
      <section className="ap-hero">
        <div className="ap-hero__bg" style={{ backgroundImage: `url(${transportImg})` }} />
        <div className="ap-hero__inner">
          <p className="ap-hero__eye">Nos Services</p>
          <h1 className="ap-hero__h1">
            Approvisionnement sécurisé,<br />
            <strong>de la commande à la livraison</strong>
          </h1>
          <p className="ap-hero__sub">
            GSSG pilote l'intégralité de votre chaîne d'approvisionnement avec rigueur, transparence et une équipe terrain opérationnelle en Chine.
          </p>
          <div className="ap-hero__actions">
            <button className="ap-btn ap-btn--primary" onClick={goContact}>Nous contacter</button>
            <a href="#ap-processus" className="ap-btn ap-btn--ghost">Notre processus</a>
          </div>
        </div>
      </section>

      {/* ── AVANTAGES ── */}
      <section className="ap-avantages">
        <div className="ap-avantages__inner">
          <p className="ap-eyebrow">Pourquoi nous choisir</p>
          <h2 className="ap-h2">Un pilotage <strong>complet et transparent</strong> de votre supply chain</h2>
          <p className="ap-lead">
            Nous sécurisons et optimisons vos approvisionnements grâce à notre réseau local, notre expertise terrain et notre suivi rigoureux à chaque étape.
          </p>
          <div className="ap-avantages__grid">
            {AVANTAGES.map((a) => (
              <div key={a.title} className="ap-card">
                <div className="ap-card__icon">{a.icon}</div>
                <h3 className="ap-card__title">{a.title}</h3>
                <p className="ap-card__desc">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EXPERT TERRAIN ── */}
      <section className="ap-expert">
        <div className="ap-expert__inner">
          <div className="ap-expert__text-col">
            <p className="ap-expert__badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Expert terrain disponible
            </p>
            <h2 className="ap-expert__h2">
              Un responsable supply chain <strong>déployable en Chine</strong> et ailleurs
            </h2>
            <p className="ap-expert__text">
              En cas de nécessité — litige critique, commande stratégique ou problème qualité majeur — GSSG peut envoyer directement sur place notre responsable supply chain.
            </p>
            <p className="ap-expert__text">
              Ayant vécu <strong style={{ color: '#e8a020' }}>10 ans en Chine</strong>, il maîtrise parfaitement les codes culturels et commerciaux locaux. Parfaitement <strong style={{ color: '#e8a020' }}>trilingue chinois, français et anglais</strong>, il intervient efficacement auprès des usines, partenaires logistiques et administrations locales, que le fournisseur soit situé en Chine ou dans tout autre pays d'Asie ou d'ailleurs.
            </p>
            <div className="ap-expert__tags">
              <span className="ap-expert__tag">Chinois</span>
              <span className="ap-expert__tag">Français</span>
              <span className="ap-expert__tag">Anglais</span>
              <span className="ap-expert__tag">10 ans en Chine</span>
              <span className="ap-expert__tag">Déployable partout</span>
            </div>
          </div>
          <div className="ap-expert__visual">
            <div className="ap-expert__stat">
              <div className="ap-expert__stat-value">10</div>
              <div className="ap-expert__stat-label">ans de présence en Chine</div>
            </div>
            <div className="ap-expert__stat">
              <div className="ap-expert__stat-value">3</div>
              <div className="ap-expert__stat-label">langues maîtrisées</div>
            </div>
            <div className="ap-expert__stat">
              <div className="ap-expert__stat-value">48h</div>
              <div className="ap-expert__stat-label">délai de mobilisation</div>
            </div>
            <div className="ap-expert__stat">
              <div className="ap-expert__stat-value">∞</div>
              <div className="ap-expert__stat-label">pays d'intervention</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── PROCESSUS ── */}
      <section className="ap-processus" id="ap-processus">
        <div className="ap-processus__inner">
          <p className="ap-eyebrow">Notre méthodologie</p>
          <h2 className="ap-h2">Un processus en <strong>6 étapes maîtrisées</strong></h2>
          <p className="ap-lead">
            De l'analyse de vos besoins à la livraison finale, chaque phase est encadrée par nos experts pour garantir délais, qualité et conformité.
          </p>
          <div className="ap-processus__steps">
            {STEPS.map((s) => (
              <div key={s.num} className="ap-step">
                <div className="ap-step__num">{s.num}</div>
                <h3 className="ap-step__title">{s.title}</h3>
                <p className="ap-step__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COMPARATIF ── */}
      <section className="ap-compare">
        <div className="ap-compare__inner">
          <p className="ap-eyebrow">Analyse comparative</p>
          <h2 className="ap-h2" style={{ color: '#ffffff' }}>Avec GSSG vs <strong>sans GSSG</strong></h2>
          <div style={{ overflowX: 'auto' }}>
            <table className="ap-compare__table">
              <thead>
                <tr>
                  <th>Critère</th>
                  <th>✓ Avec GSSG</th>
                  <th>Sans GSSG</th>
                </tr>
              </thead>
              <tbody>
                {COMPARE.map((row) => (
                  <tr key={row.aspect}>
                    <td>{row.aspect}</td>
                    <td><span className="ap-compare__check">✓</span> {row.avec}</td>
                    <td><span className="ap-compare__cross">✗</span> {row.sans}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="ap-services">
        <div className="ap-services__inner">
          <p className="ap-eyebrow">Ce que nous faisons</p>
          <h2 className="ap-h2">Nos <strong>prestations d'approvisionnement</strong></h2>
          <p className="ap-lead">Un accompagnement complet sur toute la chaîne, de la commande à la livraison.</p>
          <div className="ap-services__grid">
            {SERVICES.map((s) => (
              <div key={s.title} className="ap-service-card">
                <div className="ap-service-card__icon">{s.icon}</div>
                <h3 className="ap-service-card__title">{s.title}</h3>
                <p className="ap-service-card__desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="ap-faq">
        <div className="ap-faq__inner">
          <p className="ap-eyebrow">Questions fréquentes</p>
          <h2 className="ap-h2">Tout ce que vous devez <strong>savoir</strong></h2>
          <div className="ap-faq__list">
            {FAQS.map((faq, i) => (
              <div key={i} className="ap-faq__item">
                <button
                  className={`ap-faq__question${openFaq === i ? ' ap-faq__question--open' : ''}`}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  {faq.q}
                  <svg className="ap-faq__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>
                <div className={`ap-faq__answer${openFaq === i ? ' ap-faq__answer--open' : ''}`}>
                  {faq.a}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="ap-cta">
        <h2 className="ap-cta__h2">Prêt à optimiser votre <strong>chaîne d'approvisionnement ?</strong></h2>
        <p className="ap-cta__sub">Contactez nos experts et obtenez une analyse personnalisée sous 48h.</p>
        <button className="ap-btn ap-btn--primary" onClick={goContact}>Demander une consultation gratuite</button>
      </section>

    </div>
  );
}
